import React from 'react'

import { IconButton } from 'components/shared/IconButton/IconButton'

import styles from './StepButton.module.scss'

export const StepButton = ({ ariaLabel, icon, onClick, isDisabled }) => (
  <IconButton
    className={styles.button}
    size="medium"
    variant="outlined"
    {...{ ariaLabel, icon, onClick, isDisabled }}
  />
)
